/**
 * 采购报价 price formula (2026-06 · extracted so both the table page and the
 * create/edit dialog share one implementation).
 *
 * JS mirror of ``backend/procurement_quotes.py::_compute_pq_price`` — keep in
 * lock-step or prices will oscillate between the optimistic client value and
 * the server response.
 */
const NUM_RE = /-?\d+(?:\.\d+)?/;

export const pqNum = (v) => {
  if (v === null || v === undefined || v === "") return 0;
  if (typeof v === "number") return Number.isFinite(v) ? v : 0;
  const m = String(v).match(NUM_RE);
  return m ? parseFloat(m[0]) : 0;
};

export const computePqPrice = (row) => {
  const subtotal =
    pqNum(row.price_per_meter) * pqNum(row.material_size) +
    pqNum(row.processing_fee) + pqNum(row.brand_paper) +
    pqNum(row.plastic_bag) + pqNum(row.liner_board) +
    pqNum(row.carton_freight) + pqNum(row.others) +
    // 2026-06 · 其他1/2/3（FM 只读）也计入
    pqNum(row.others1) + pqNum(row.others2) + pqNum(row.others3);
  return Math.round(subtotal * (1 + pqNum(row.profit_tax)) * 10000) / 10000;
};
